module.exports = __webpack_public_path__ + "img/buddy_nose-05.62645185.svg";